import { FC, HTMLProps } from 'react';

export const QrsIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M5.25 4C4.55964 4 4 4.55964 4 5.25V8C4 8.55228 3.55228 9 3 9C2.44772 9 2 8.55228 2 8V5.25C2 3.45507 3.45507 2 5.25 2H8C8.55228 2 9 2.44772 9 3C9 3.55228 8.55228 4 8 4H5.25ZM5.25 20C4.55964 20 4 19.4404 4 18.75V16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V18.75C2 20.5449 3.45507 22 5.25 22H8C8.55228 22 9 21.5523 9 21C9 20.4477 8.55228 20 8 20H5.25ZM20 5.25C20 4.55964 19.4404 4 18.75 4H16C15.4477 4 15 3.55228 15 3C15 2.44772 15.4477 2 16 2H18.75C20.5449 2 22 3.45507 22 5.25V8C22 8.55228 21.5523 9 21 9C20.4477 9 20 8.55228 20 8V5.25ZM18.75 20C19.4404 20 20 19.4404 20 18.75V16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16V18.75C22 20.5449 20.5449 22 18.75 22H16C15.4477 22 15 21.5523 15 21C15 20.4477 15.4477 20 16 20H18.75ZM7 7H10V10H7V7ZM14 10H10V14H7V17H10V14H14V17H17V14H14V10ZM14 10V7H17V10H14Z"
        fill="currentColor"
      />
    </svg>
  );
};
